module.exports = __webpack_public_path__ + "static/media/awfxex32_121.623d3661.ico";